import Vue from "vue";

Vue.mixin({
  methods: {
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    formatMoney(value) {
      let formattedInput = new Intl.NumberFormat().format(value);
      if (value != "-") {
        return "€ " + formattedInput + ",-";
      } else {
        return value;
      }
    },
    encodeURLUmbracoFriendly(str) {
      // remove '.' because Umbraco doesn't like them. '.' usually denotes a file instead of a page.
      // https://our.umbraco.com/forum/using-umbraco-and-getting-started/102307-allow-dot-in-url
      return encodeURIComponent(str.replace(' ', "").replace(/\./g, ""));
    },
  },
});